import { render, staticRenderFns } from "./Webconstruction.vue?vue&type=template&id=01fe5d59&scoped=true"
import script from "./Webconstruction.vue?vue&type=script&lang=js"
export * from "./Webconstruction.vue?vue&type=script&lang=js"
import style0 from "./Webconstruction.vue?vue&type=style&index=0&id=01fe5d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe5d59",
  null
  
)

export default component.exports